/**
 * Legal and checkout settings for this site: what the policies say is sold,
 * the name on card statements, the terms version recorded with every purchase,
 * and the colours of the agreement box and the confirmation screen.
 * Used by config/legalContent.ts, pages/LegalPage.tsx and components/legal/*.
 */

import { SUPPORT_EMAIL, SITE_DOMAIN } from './brandConfig'

/** Recorded with every purchase. Move both forward whenever the wording changes. */
export const TERMS_VERSION = '2026-09-25'
export const TERMS_UPDATED = 'September 25, 2026'

export const LEGAL = {
  siteTitle: 'Braydin Wright',
  creator: 'Braydin',
  domain: SITE_DOMAIN,
  supportEmail: SUPPORT_EMAIL,
  /** How charges appear on the fan's card statement (the Stripe account's descriptor). */
  statementName: 'PHOTODUMP.COM',
  refundDays: 14,
  offer: {
    renews: false as boolean,
    name: '1 Full Year of Access',
    price: '$50',
    length: '1 full year',
    endsAfter: 'one year',
    days: 365,
    welcome: 'Welcome! You now have 1 full year of access.',
    checklist: ['Access to all content', 'New updates included', 'No auto renewal'],
    chargeLine: 'Secure payment via Stripe. Your card will be charged once for one year of access. No auto renewal.',
  },
}

export const LEGAL_STYLE = {
  checkbox: 'accent-[#6b7850]',
  link: 'font-medium text-[#5c5b44] underline underline-offset-2',
  check: 'text-green-600',
  button: 'bg-[#6b7850] hover:bg-[#5c5b44] text-white',
}
